export default __webpack_public_path__ + "static/media/Learn_SQL_-_adamr.space___Codecademy.5c9b73c3.pdf";